module.exports = __webpack_public_path__ + "img/franchising_help_construction.e9aff3d2.png";